import { render } from "./DRBoxing.vue?vue&type=template&id=158589fa"
import script from "./DRBoxing.vue?vue&type=script&lang=js"
export * from "./DRBoxing.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tasselchof/CodeProjects/oarus/oarus-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import qInstall from "../../../../../../../../oarus-app/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCardSection,QLinearProgress,QBtn,QBtnGroup,QItem,QPagination});
